import ConciergeContainer from './containers/ConciergeContainer.jsx'

// Sync route definition
export default {
  path      : '/concierge',
  component : ConciergeContainer
}



// WEBPACK FOOTER //
// ./src/routes/Concierge/index.js